import { useState } from "react";
import { Card, CardBody, Collapse } from "reactstrap";
import { Image } from "../../../../../AbstractElements";
import { AddFriend, FollowingsTitle, Href } from "../../../../../Constants/Constants";
import { FollowingData } from "../../../../../Data/Applications/SocialApp/SocialApp";
import { dynamicImage } from "../../../../../Utils";
import HeaderWithIcon from "../HeaderWithIcon";

const FollowingsCard = () => {
  const [isOpen, setIsOpen] = useState(true);

  return (
    <Card>
      <HeaderWithIcon Heading={FollowingsTitle} isOpen={isOpen} setIsOpen={setIsOpen} />
      <Collapse isOpen={isOpen}>
        <CardBody className="social-list filter-cards-view">
          {FollowingData.map((data, index) => (
            <div className="d-flex" key={index}>
              <Image className="img-50 img-fluid m-r-20 rounded-circle" alt="image" src={dynamicImage(`user/${data.imageName}`)} />
              <div className="flex-grow-1">
                <span className="d-block">{data.name}</span>
                <a href={Href}>{AddFriend}</a>
              </div>
            </div>
          ))}
        </CardBody>
      </Collapse>
    </Card>
  );
};

export default FollowingsCard;
